module.exports = __webpack_public_path__ + "img/9.f4838522.jpg";